import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class SocialNetworkMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.socialNetwork.socialNetworkMapperError"));

        Object.setPrototypeOf(this, SocialNetworkMapperError.prototype);
    }
}